import {apiAction, dataAction, staticAction, silentApiAction} from "actions/actionWrappers";
import {getRoomDetails, startNewVideo, logVideoRoomEvent, submitConsent as submitConsentApi, getMeetingSummaryRatingStatus} from "api/video";
import {actions} from "reducers/videoReducer";
import {getChatInstance} from "chat/WebSocket";
import {addMessages, addNewMessageToChannel, updateUnreadCount} from "actions/chatAction";
import {fetchChatChannels} from "api/chatApi";
import {getChannelFor} from "business/channel";
import {actions as mentorshipAction} from "reducers/mentorshipReducer";
import moment from "moment";
import {isEmpty} from "lodash";

const callErrorMessage = (e) =>
  e?.response?.data?.detail || "Could not start the call. Please try again.";

const startVideo = (channel, isVideoRoomActiveForChatChannel) => async (dispatch) => {
  dispatch(dataAction(actions.START_VIDEO, channel));
  let room;
  try {
    room = await dispatch(apiAction(startNewVideo, channel.channelId));
  } catch (e) {
    dispatch(staticAction(actions.CALL_ENDED));
    throw e;
  }
  dispatch(dataAction(actions.STORE_ROOM_DETAILS, {room, channel}));
  const chatInstance = getChatInstance();
  chatInstance.addCallbacks((messages, nextPage, type) => dispatch(addMessages(messages, nextPage, type)),
    (message) => dispatch(addNewMessageToChannel(message)), (message) => dispatch(updateUnreadCount(message)));
  if (!isVideoRoomActiveForChatChannel) {
    await chatInstance.newChatMessage(
        {text: JSON.stringify({room: room.room}), channelId: channel.channelId, attachments: [], tempId: null}
      );
  }
  return room;
};

const joinVideo = (roomId) => async (dispatch, getState) => {
  dispatch(dataAction(actions.START_VIDEO, {}));
  const {chat: {chatChannels} } = getState();
  let room;
  try {
    room = await dispatch(apiAction(getRoomDetails, roomId));
  } catch (e) {
    if (e?.response?.status !== 409) {
      throw e;
    }
    dispatch(dataAction(actions.CALL_FAILED, callErrorMessage(e)));
    return;
  }
  const channel = getChannelFor(room.channel, chatChannels);
  dispatch(dataAction(actions.STORE_ROOM_DETAILS, {room, channel}));
  // The chat list only loads on the chat pages, so a call opened from anywhere
  // else has no partner to name in the header until it is fetched here.
  if (isEmpty(channel)) {
    try {
      const channels = await dispatch(silentApiAction(fetchChatChannels));
      if (getState().video.room.room === room.room) {
        dispatch(dataAction(actions.STORE_CALL_CHANNEL, getChannelFor(room.channel, channels)));
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const logVideoEvent = (roomId, eventName, jitsiParticipantId) => (dispatch) => {
  if (jitsiParticipantId) {
    dispatch(apiAction(logVideoRoomEvent, roomId, eventName, jitsiParticipantId, moment().toISOString(true)));
  }
}

const callEnded = () => dispatch => dispatch(staticAction(actions.CALL_ENDED));

const submitConsent = (roomId, consent) => async (dispatch) => {
  await dispatch(apiAction(submitConsentApi, roomId, consent));
};

const getMeetingRatingStatus = () => async (dispatch, getState) => {
  try {
    const {auth: {user: {id}}} = getState();
    const meetingSummaryRating = await dispatch(silentApiAction(getMeetingSummaryRatingStatus, id));
    dispatch(dataAction(mentorshipAction.GET_MEETING_SUMMARY_RATING_STATUS, {meetingSummaryRating}))
  } catch (e) {
    console.log(e);
  }
}


export {
  callErrorMessage,
  startVideo,
  callEnded,
  joinVideo,
  logVideoEvent,
  submitConsent,
  getMeetingRatingStatus,
};
